export const externalVesselUrl = (mmsi: number | string) => {
    return `https://www.marinetraffic.com/en/ais/details/ships/mmsi:${mmsi}`;
};
export const externalMarineTrafficByIMO = (imo: number) => {
    return `https://www.marinetraffic.com/en/ais/details/ships/imo:${imo}`;
};
